import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';

const initialState = () => ({
  profiles: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getSyncProfiles({ commit }) {
    commit('GET_SYNC_PROFILES');
    return opportunitySyncProfilesService.getOpportunitySyncProfiles().then(
      (response) => {
        commit('SUCCESS_GET_SYNC_PROFILES', response);
        return response;
      },
      (error) => {
        commit('ERROR_GET_SYNC_PROFILES', error);
        throw error;
      },
    );
  },
  createSyncProfile({ commit }, profile) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.createSyncProfile(profile).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
  updateSyncProfile({ commit }, { profileId, profile }) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.updateSyncProfile(profileId, profile).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
  deleteSyncProfile({ commit }, profileId) {
    commit('MUTATE_START');
    return opportunitySyncProfilesService.deleteSyncProfile(profileId).then(
      (response) => {
        commit('MUTATE_SUCCESS');
        return response;
      },
      (error) => {
        commit('MUTATE_ERROR', error);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_SYNC_PROFILES(state) {
    state.status = { error: null, pending: true, resolved: false, rejected: false };
  },
  SUCCESS_GET_SYNC_PROFILES(state, profiles) {
    state.status = { ...state.status, pending: false, resolved: true };
    state.profiles = profiles;
  },
  ERROR_GET_SYNC_PROFILES(state, error) {
    state.status = { error, pending: false, resolved: false, rejected: true };
    state.profiles = [];
  },
  MUTATE_START(state) {
    state.status = { ...state.status, error: null, pending: true };
  },
  MUTATE_SUCCESS(state) {
    state.status = { ...state.status, pending: false, resolved: true };
  },
  MUTATE_ERROR(state, error) {
    state.status = { error, pending: false, resolved: false, rejected: true };
  },
};

const getters = {
  profiles: (state) => state.profiles,
  pending: (state) => state.status.pending,
  error: (state) => state.status.error,
};

export const adminSyncProfiles = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
